export const formatPercent = (num: number | undefined) => {
    return (num ?? 0).toLocaleString(undefined, {
        style: "percent",
        minimumFractionDigits: 2,
    });
};

export const formatCurrency = (num: number | undefined) => {
    return "$ " + (num ?? 0).toFixed(2);
};
